<script setup></script>

<template>
  <div class="admin">
    <router-view />
  </div>
</template>

<style scoped>
.admin {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  z-index: 5;
  background-color: #fffbf8;
}
</style>
